import styled from '@emotion/styled';
import { dialogClasses } from '@mui/material';
import { useTranslations } from 'next-intl';

import { IModalProps, Modal } from '@web/ui/components/modal';
import { SharpImage } from '@web/ui/components/SharpImage';
import { PersonaLogoCompact } from '@web/ui/icons';

import { SignInWallet } from '../SignInWallet';

import backgroundImage from './connect-modal.png';

const StyledModal = styled(Modal)`
  .${dialogClasses.paper} {
    max-width: 360px;
    padding: 0;
    gap: 0;
  }

  .${dialogClasses.paperScrollBody} {
    max-width: 360px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
`;

const HeaderImage = styled(SharpImage)`
  max-height: 100%;
  width: 100%;
  height: auto;
`;

const Logo = styled(PersonaLogoCompact)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ theme }) => theme.size['4000']};
  height: ${({ theme }) => theme.size['4000']};
  color: ${({ theme }) => theme.color.onBackground};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing('2000')};
  padding: ${({ theme }) => theme.spacing('2000')};
  padding-top: ${({ theme }) => theme.spacing('3000')};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1000')};
  box-sizing: border-box;
  text-align: center;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.color.onSurface};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['4']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  text-transform: ${({ theme }) => theme.textTransform.capitalize};
`;

export const Content = styled.p`
  color: ${({ theme }) => theme.color.onSurfaceVariant};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1500')};
`;

const CancelAction = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.color.onSurface};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};

  text-align: center;
`;

export function ConnectModal(props: IModalProps) {
  const t = useTranslations();

  return (
    <StyledModal {...props}>
      <ImageContainer>
        <HeaderImage
          src={backgroundImage}
          alt="Connect modal background image"
        />
        <Logo />
      </ImageContainer>
      <ContentContainer>
        <TextContainer>
          <Title>{t('CONNECT_MODAL_TITLE')}</Title>
          <Content>{t('CONNECT_MODAL_CONTENT')}</Content>
        </TextContainer>
        <Actions>
          <SignInWallet fullWidth />
          <CancelAction onClick={props.onClose}>
            {t('CONNECT_MODAL_ACTION_CANCEL')}
          </CancelAction>
        </Actions>
      </ContentContainer>
    </StyledModal>
  );
}
